import React, { useEffect, useState } from 'react';
import { Button, Col, Container, FormControl, InputGroup, Row, Form, Modal, Image } from "react-bootstrap";
import axios from "axios";
import '../../Assets/css/footer.css';
import BwLogo from '../../Assets/images/white-logo.png';
import { Link, NavLink } from 'react-router-dom';
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material/';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import swal from "sweetalert";
import rapnet from '../../Assets/images/home/rapnet.webp';
import overnight from '../../Assets/images/home/overnight-logo.webp';
import vdb from '../../Assets/images/home/vdb.webp';
import WPimg from "../../Assets/images/wp-img.jpg";
import BelgiumLogo from '../../Assets/images/home/bw-logo.svg';
import ivouch from '../../Assets/images/home/ivouch.webp';
import yelp from '../../Assets/images/home/yelp-logo.webp';
import google from '../../Assets/images/home/google.webp';
import paypal from '../../Assets/images/home/paypal.webp';
import { Address_details, Email_details, Email_detailsSecond, client_name, contact_number, media_details } from '../../Helpers/request';
import { isDesktop } from 'react-device-detect';
import { useSelector } from "react-redux";
import { base_url, postHeader } from '../../Helpers/request';
import { FloatingWhatsApp } from 'react-floating-whatsapp';
import { useTranslation } from 'react-i18next'
const Footer = () => {
   const { t } = useTranslation()
  const [screenWidth, setScreenWidth] = useState(window.screen.width);
  const resizeScreen = () => {
    setScreenWidth(window.innerWidth);
  };
  useEffect(() => {
    resizeScreen();
    window.addEventListener("resize", resizeScreen);
    return () => {
      window.removeEventListener("resize", resizeScreen);
    };
  });
  const currencycode = useSelector(
    (state) => state.persistedReducer.home.currencycode
  );
  const [newsletteremail, setNewsletteremail] = useState("");
  const [loader, setLoader] = useState(false);
  const newsletter = (e) => {
    e.preventDefault();
    setLoader(true);
    const data = {
      currency_code: currencycode,
      email: newsletteremail,
    };
    axios
      .post(base_url + "/common/subscribe_newsletter", data, {
        headers: postHeader,
      })
      .then((res) => {
        if (res.data.status == 1) {
          setLoader(false);
          setNewsletteremail("");
          return swal(res.data.message, "", "success");
        } else {
          setLoader(false);
          return swal(res.data.message, "", "error");
        }
      })
      .catch((error) => {
        setLoader(false);
        console.log(error);
      });
  };


  const [expanded, setExpanded] = React.useState(false);
  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      <div className="rcs_footer" id="rcs_footer">
        <Container fluid className="showcase-container rcs_custom_home_container">
          <div className="d-none d-lg-block">
            <Row className="justify-content-between">
              <Col xs={12} sm={6} md={6} lg={2} xl={3}>
                <div className='rcs_footer_content rcs_info'>
                  <h2>{t('footer.quickLinks.title')} </h2>
                  <ul className='rcs_footer_list'>
                    <li><NavLink to="/about">{t('footer.quickLinks.aboutUs')}</NavLink></li>
                    <li><NavLink to="/contact">{t('footer.quickLinks.contact')}</NavLink></li>
                    {/* <li><NavLink to="/blog">Blog</NavLink></li> */}
                    <li><NavLink to="/education">{t('footer.quickLinks.education')}</NavLink></li>
                    <li><NavLink to="/privacy-policy">{t('footer.quickLinks.privacyPolicy')}</NavLink></li>
                    <li><NavLink to="/cookies"> {t('footer.quickLinks.cookies')} </NavLink></li>
                    <li><NavLink to="/returns-and-exchanges">{t('footer.quickLinks.returnPolicy')} </NavLink></li>
                    <li><NavLink to="/payment"> {t('footer.quickLinks.paymentMethods')} </NavLink></li>
                    <li><NavLink to="/terms-and-conditions">{t('footer.quickLinks.termsConditions')} </NavLink></li>
                    {/* <li><NavLink to="/faq"> FAQ </NavLink></li> */}
                    {/* <li><NavLink to="/make-an-appointment">Virtual Appointment</NavLink></li> */}
                  </ul>
                </div>
              </Col>
              <Col xs={12} sm={6} md={6} lg={2} xl={3}>
                <div className="rcs_footer_content rcs_info">
                  <h2>{t('footer.collection.title')}</h2>
                  <ul className="rcs_footer_list">
                    {/* <li><NavLink to="/fashion-rings">Rings</NavLink></li> */}
                    {/* <li><NavLink to="/necklaces">Necklaces</NavLink></li> */}
                    <li><NavLink to="/fine-jewelry/pendants">{t('footer.collection.pendants')}</NavLink></li>
                    <li><NavLink to="/fine-jewelry/bracelets">{t('footer.collection.bracelets')}</NavLink></li>
                    <li><NavLink to="/fine-jewelry/earrings">{t('footer.collection.earrings')}</NavLink></li>
                  </ul>
                </div>
              </Col>
              <Col xs={12} sm={6} md={6} lg={3} xl={3}>
                <div className='rcs_footer_content rcs_info'>
                  <h2> {t('footer.contact.title')} </h2>
                  <ul className="rcs_footer_list">
                    {/* <p className='mt-0'>Address: </p> */}
                    <li onClick={() => { window.open(Address_details.link, '_blank') }}>

                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5 10.5005C14.5 9.11924 13.3808 8 12.0005 8C10.6192 8 9.5 9.11924 9.5 10.5005C9.5 11.8808 10.6192 13 12.0005 13C13.3808 13 14.5 11.8808 14.5 10.5005Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9995 21C10.801 21 4.5 15.8984 4.5 10.5633C4.5 6.38664 7.8571 3 11.9995 3C16.1419 3 19.5 6.38664 19.5 10.5633C19.5 15.8984 13.198 21 11.9995 21Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>

                      {Address_details.textLine1}
                      <br />
                      {Address_details.textLine2}
                    </li>

                    <li onClick={(e) => { window.location.href = contact_number.link }}>
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5317 12.4724C15.5208 16.4604 16.4258 11.8467 18.9656 14.3848C21.4143 16.8328 22.8216 17.3232 19.7192 20.4247C19.3306 20.737 16.8616 24.4943 8.1846 15.8197C-0.493478 7.144 3.26158 4.67244 3.57397 4.28395C6.68387 1.17385 7.16586 2.58938 9.61449 5.03733C12.1544 7.5765 7.54266 8.48441 11.5317 12.4724Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg>
                      {contact_number.text}</li>

                    <li className='wa-li'>
                      <a href='https://wa.me/+34649891997' target='_blank'>
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <g clip-path="url(#clip0_104_1131)">
                            <path d="M18.3456 14.0137L14.8868 12.2843C14.6789 12.1809 14.4315 12.1966 14.2383 12.3254L12.5435 13.4549C11.6855 13.0157 10.9874 12.3176 10.5482 11.4596L11.6788 9.76587C11.8076 9.57263 11.8233 9.32527 11.7199 9.11734L9.99045 5.65853C9.88077 5.4378 9.65543 5.29832 9.40894 5.2986C7.14052 5.2986 5.30162 7.13751 5.30162 9.40593C5.30757 14.5372 9.46584 18.6955 14.5971 18.7015C16.8655 18.7014 18.7045 16.8625 18.7045 14.5941C18.7045 14.3483 18.5656 14.1235 18.3456 14.0137ZM14.5971 17.4044C10.1819 17.3991 6.60402 13.8211 6.59866 9.40593C6.59879 8.00347 7.63289 6.81578 9.02199 6.62268L10.3904 9.35945L9.26735 11.0435C9.14751 11.2238 9.12561 11.4521 9.20898 11.652C9.80532 13.0698 10.9332 14.1978 12.3511 14.7941C12.5509 14.8775 12.7792 14.8556 12.9596 14.7357L14.6436 13.6127L17.3804 14.9811C17.1873 16.3702 15.9996 17.4043 14.5971 17.4044ZM12.003 0.975098C3.64173 0.973305 -1.67831 9.91563 2.31299 17.2628L1.05702 21.0318C0.688491 22.1369 1.65442 23.2265 2.79568 22.9931C2.85509 22.9809 2.91372 22.9652 2.97125 22.9461L6.74026 21.6901C14.1997 25.7381 23.2439 20.1931 23.0199 11.709C22.8622 5.73721 17.9769 0.977409 12.003 0.975098ZM12.003 21.7279C10.293 21.7283 8.61312 21.278 7.13261 20.4222C7.03392 20.3655 6.9222 20.3353 6.80835 20.3347C6.73857 20.3351 6.66928 20.3464 6.60299 20.3682L2.56159 21.7149C2.40373 21.7676 2.24808 21.6296 2.28141 21.4666C2.28314 21.4581 2.28539 21.4497 2.28813 21.4415L3.6349 17.4044C3.69385 17.2279 3.67416 17.0347 3.58086 16.8737C-0.170895 10.3928 4.50007 2.28081 11.9886 2.27215C19.4771 2.2635 24.1668 10.3647 20.43 16.8542C18.6944 19.8685 15.4813 21.7268 12.003 21.7279Z" fill="black" />
                          </g>
                          <defs>
                            <clipPath id="clip0_104_1131">
                              <rect width="24" height="24" fill="white" />
                            </clipPath>
                          </defs>
                        </svg>
                        {contact_number.chat}</a></li>
                    <li>
                     <a href={`mailto:contact@manuelspinosa.com`}>
                  <img style={{width:"24px", marginRight: "10px"}} className='img-fluid' src={require("../../Assets/newImg/envelop.jpg")}/>
                  contact@manuelspinosa.com
                     </a>

                    </li>

                  </ul>
                </div>
              </Col>
              <Col xs={12} sm={6} md={6} lg={5} xl={3} className='d-flex justify-content-end'>
                <div className='rcs_footer_content'>
                  <h2> Get Latest Updates </h2>
                  <p>
                    We’ll send you insider news, styling
                    tips, and exclusive updates.
                  </p>
                  <div className="rcs_signup_to_input_field">
                    <Form className="gs_news_form w-100" onSubmit={newsletter}>
                      <InputGroup>
                        <FormControl
                          aria-label="Recipient's username"
                          aria-describedby="basic-addon2"
                          type="email"
                          value={newsletteremail}
                          placeholder="Email"
                          required
                          onChange={(e) => setNewsletteremail(e.target.value)}
                        />
                        <Button
                          className="btn outline-base-btn large"
                          type="submit"
                          id="button-addon2"
                        >
                          Subscribe
                        </Button>
                      </InputGroup>
                    </Form>
                  </div>

                  <ul className="d-flex align-items-center gap-20">
                    {
                      media_details.map((media, id) =>
                        <li key={id}>
                          <div className="rcs_footer_content_one_social_icn_div">
                            <a href={media.account_link} target="_blank">
                              <img src={media.account_img} alt={media.account_alt} />
                            </a>
                          </div>
                        </li>
                      )}
                  </ul>
                </div>
              </Col>

              {/* <Col xs={12} sm={6} md={6} lg={2}>
                <div className='rcs_footer_content'>
                  <h2>Help</h2>
                  <ul className='rcs_footer_list'>
                    <li><NavLink to="/faq">FAQ’s</NavLink></li>
                    <li><NavLink to="/contact">Contact Us</NavLink></li>
                  </ul>
                </div>
              </Col> */}
            </Row>
          </div>
        </Container>
      </div>
      <section className="d-lg-none d-md-block rcs_mobile_footer_section">
        <Container>
          <div className="gs_footer_content d-lg-none d-md-block  ">
            {
              screenWidth < 990 && <div id="google_translate_element" className=''></div>
            }
            <Row className="m-0 w-100">

              <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                  className="rcs_footer_t_color_white"
                >
                  <span className="footer-mobile-heading"> Quick Links </span>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <div className="block-footer3">
                      <ul className='rcs_footer_list'>
                        <li><NavLink to="/about">  About Us</NavLink></li>
                        <li><NavLink to="/contact"> Contact Us </NavLink></li>
                        {/* <li><NavLink to="/blog">Blog</NavLink></li> */}
                        <li><NavLink to="/education">Education</NavLink></li>
                        <li><NavLink to="/privacy-policy"> Privacy Policy </NavLink></li>
                        <li><NavLink to="/cookies"> Cookies </NavLink></li>
                        <li><NavLink to="/returns-and-exchanges"> Return Policy </NavLink></li>
                        <li><NavLink to="/payment"> Payment Method </NavLink></li>
                        <li><NavLink to="/terms-and-conditions"> Terms and Conditions </NavLink></li>
                        {/* <li><NavLink to="/faq"> FAQ </NavLink></li> */}
                        {/* <li><NavLink to="/make-an-appointment">Virtual Appointment</NavLink></li> */}
                      </ul>
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel3bh-content"
                  id="panel3bh-header"
                  className="rcs_footer_t_color_white"
                >
                  <span className='footer-mobile-heading'>Collection</span>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <div className="block-footer3">
                      <ul className='rcs_footer_list contact-foter2'>
                        {/* <li><NavLink to="/fashion-rings">Rings</NavLink></li> */}
                        <li><NavLink to="/fine-jewelry/pendants">Pendants</NavLink></li>
                        <li><NavLink to="/fine-jewelry/bracelets">Bracelets</NavLink></li>
                        <li><NavLink to="/fine-jewelry/earrings">Earrings</NavLink></li>
                        {/* <li><NavLink to="/necklaces">Necklaces</NavLink></li> */}
                      </ul>
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion>
              <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4bh-content"
                  id="panel4bh-header"
                  className="rcs_footer_t_color_white"
                >
                  <span className='footer-mobile-heading'>Get in Touch</span>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <div className="block-footer3">
                      <ul className="list-none contact-foter2">
                        {/* <p className='mt-0'>Address: </p> */}
                        <li onClick={() => { window.open(Address_details.link, '_blank') }}>

                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.5 10.5005C14.5 9.11924 13.3808 8 12.0005 8C10.6192 8 9.5 9.11924 9.5 10.5005C9.5 11.8808 10.6192 13 12.0005 13C13.3808 13 14.5 11.8808 14.5 10.5005Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.9995 21C10.801 21 4.5 15.8984 4.5 10.5633C4.5 6.38664 7.8571 3 11.9995 3C16.1419 3 19.5 6.38664 19.5 10.5633C19.5 15.8984 13.198 21 11.9995 21Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>

                          {Address_details.textLine1}
                          <br />
                          {Address_details.textLine2}
                        </li>

                        <li onClick={(e) => { window.location.href = contact_number.link }}>

                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5317 12.4724C15.5208 16.4604 16.4258 11.8467 18.9656 14.3848C21.4143 16.8328 22.8216 17.3232 19.7192 20.4247C19.3306 20.737 16.8616 24.4943 8.1846 15.8197C-0.493478 7.144 3.26158 4.67244 3.57397 4.28395C6.68387 1.17385 7.16586 2.58938 9.61449 5.03733C12.1544 7.5765 7.54266 8.48441 11.5317 12.4724Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>

                          {contact_number.text}</li>

                        <li className='wa-li mb-3'>
                          <a href='https://wa.me/+34649891997' target='_blank'>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <g clip-path="url(#clip0_104_1131)">
                                <path d="M18.3456 14.0137L14.8868 12.2843C14.6789 12.1809 14.4315 12.1966 14.2383 12.3254L12.5435 13.4549C11.6855 13.0157 10.9874 12.3176 10.5482 11.4596L11.6788 9.76587C11.8076 9.57263 11.8233 9.32527 11.7199 9.11734L9.99045 5.65853C9.88077 5.4378 9.65543 5.29832 9.40894 5.2986C7.14052 5.2986 5.30162 7.13751 5.30162 9.40593C5.30757 14.5372 9.46584 18.6955 14.5971 18.7015C16.8655 18.7014 18.7045 16.8625 18.7045 14.5941C18.7045 14.3483 18.5656 14.1235 18.3456 14.0137ZM14.5971 17.4044C10.1819 17.3991 6.60402 13.8211 6.59866 9.40593C6.59879 8.00347 7.63289 6.81578 9.02199 6.62268L10.3904 9.35945L9.26735 11.0435C9.14751 11.2238 9.12561 11.4521 9.20898 11.652C9.80532 13.0698 10.9332 14.1978 12.3511 14.7941C12.5509 14.8775 12.7792 14.8556 12.9596 14.7357L14.6436 13.6127L17.3804 14.9811C17.1873 16.3702 15.9996 17.4043 14.5971 17.4044ZM12.003 0.975098C3.64173 0.973305 -1.67831 9.91563 2.31299 17.2628L1.05702 21.0318C0.688491 22.1369 1.65442 23.2265 2.79568 22.9931C2.85509 22.9809 2.91372 22.9652 2.97125 22.9461L6.74026 21.6901C14.1997 25.7381 23.2439 20.1931 23.0199 11.709C22.8622 5.73721 17.9769 0.977409 12.003 0.975098ZM12.003 21.7279C10.293 21.7283 8.61312 21.278 7.13261 20.4222C7.03392 20.3655 6.9222 20.3353 6.80835 20.3347C6.73857 20.3351 6.66928 20.3464 6.60299 20.3682L2.56159 21.7149C2.40373 21.7676 2.24808 21.6296 2.28141 21.4666C2.28314 21.4581 2.28539 21.4497 2.28813 21.4415L3.6349 17.4044C3.69385 17.2279 3.67416 17.0347 3.58086 16.8737C-0.170895 10.3928 4.50007 2.28081 11.9886 2.27215C19.4771 2.2635 24.1668 10.3647 20.43 16.8542C18.6944 19.8685 15.4813 21.7268 12.003 21.7279Z" fill="black" />
                              </g>
                              <defs>
                                <clipPath id="clip0_104_1131">
                                  <rect width="24" height="24" fill="white" />
                                </clipPath>
                              </defs>
                            </svg>
                            {contact_number.chat}</a></li>
                            <li>
                     <a href={`mailto:contact@manuelspinosa.com`}>
                  <img style={{width:"24px", marginRight: "10px"}} className='img-fluid' src={require("../../Assets/newImg/envelop.jpg")}/>
                  contact@manuelspinosa.com
                     </a>

                    </li>
                        {/* <li onClick={(e) => { window.location.href = Email_details.link }}>

<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.1162 2.5C15.2337 2.5 16.3087 2.94167 17.0995 3.73417C17.8912 4.525 18.3337 5.59167 18.3337 6.70833V13.2917C18.3337 15.6167 16.442 17.5 14.1162 17.5H5.88366C3.55783 17.5 1.66699 15.6167 1.66699 13.2917V6.70833C1.66699 4.38333 3.54949 2.5 5.88366 2.5H14.1162ZM15.442 7.95L15.5087 7.88333C15.7078 7.64167 15.7078 7.29167 15.4995 7.05C15.3837 6.92583 15.2245 6.85 15.0587 6.83333C14.8837 6.82417 14.717 6.88333 14.5912 7L10.8337 10C10.3503 10.4008 9.65783 10.4008 9.16699 10L5.41699 7C5.15783 6.80833 4.79949 6.83333 4.58366 7.05833C4.35866 7.28333 4.33366 7.64167 4.52449 7.89167L4.63366 8L8.42533 10.9583C8.89199 11.325 9.45783 11.525 10.0503 11.525C10.6412 11.525 11.217 11.325 11.6828 10.9583L15.442 7.95Z" fill="#F7F2F5" />
</svg>
{Email_details.text}</li>
<li onClick={(e) => { window.location.href = Email_detailsSecond.link }}>
<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M14.1162 2.5C15.2337 2.5 16.3087 2.94167 17.0995 3.73417C17.8912 4.525 18.3337 5.59167 18.3337 6.70833V13.2917C18.3337 15.6167 16.442 17.5 14.1162 17.5H5.88366C3.55783 17.5 1.66699 15.6167 1.66699 13.2917V6.70833C1.66699 4.38333 3.54949 2.5 5.88366 2.5H14.1162ZM15.442 7.95L15.5087 7.88333C15.7078 7.64167 15.7078 7.29167 15.4995 7.05C15.3837 6.92583 15.2245 6.85 15.0587 6.83333C14.8837 6.82417 14.717 6.88333 14.5912 7L10.8337 10C10.3503 10.4008 9.65783 10.4008 9.16699 10L5.41699 7C5.15783 6.80833 4.79949 6.83333 4.58366 7.05833C4.35866 7.28333 4.33366 7.64167 4.52449 7.89167L4.63366 8L8.42533 10.9583C8.89199 11.325 9.45783 11.525 10.0503 11.525C10.6412 11.525 11.217 11.325 11.6828 10.9583L15.442 7.95Z" fill="#F7F2F5" />
</svg>{Email_detailsSecond.text}</li> */}
                      </ul>
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion>

              {/* <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel4bh-content"
                  id="panel4bh-header"
                  className="rcs_footer_t_color_white"
                >
                  <span className='footer-mobile-heading'>Help</span>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    <div className="block-footer3">
                      <ul className='rcs_footer_list contact-foter2'>
                        <li><NavLink to="/faq">FAQ’s</NavLink></li>
                        <li><NavLink to="/contact">Contact Us</NavLink></li>
                      </ul>
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion> */}

              <Col xs={12} className="mt-3 px-0">
                <div className='rcs_footer_content'>
                  <h2 className='mt-0'> Get Latest Updates </h2>
                  <p>
                    We’ll send you insider news, styling
                    tips, and exclusive updates.
                  </p>
                  <div className="rcs_signup_to_input_field">
                    <Form className="gs_news_form w-100" onSubmit={newsletter}>
                      <InputGroup>
                        <FormControl
                          aria-label="Recipient's username"
                          aria-describedby="basic-addon2"
                          type="email"
                          value={newsletteremail}
                          placeholder="Email"
                          required
                          onChange={(e) => setNewsletteremail(e.target.value)}
                        />
                        <Button
                          className="btn outline-base-btn large"
                          type="submit"
                          id="button-addon2"
                        >
                          Subscribe
                        </Button>
                      </InputGroup>
                    </Form>
                  </div>

                  <ul className="d-flex align-items-center gap-20">
                    {
                      media_details.map((media, id) =>
                        <li key={id}>
                          <div className="rcs_footer_content_one_social_icn_div">
                            <a href={media.account_link} target="_blank">
                              <img src={media.account_img} alt={media.account_alt} />
                            </a>
                          </div>
                        </li>
                      )}
                  </ul>
                </div>
                {/* <div className='rcs_footer_content_one '>
                  <div className="logo">
                    <NavLink to="/"><Image height='52' src={BwLogo} alt={client_name.c_name} /></NavLink>
                  </div>
                  <p> {client_name.c_name} in the field of the Diamond industry with an experience of over 25 years. We revolutionized the industry with a disruptive online business model. <br /><Link to='/our-story'>Read More</Link></p>
                </div> */}
                {/* <div className="rcs_footer_content_one_social_icn">
                  <ul>
                    {
                      media_details.map((media) =>
                        <li>
                          <div className="rcs_footer_content_one_social_icn_div">
                            <a href={media.account_link} target='_blank' rel="noreferrer">{media.account_icon}</a>
                          </div>
                        </li>
                      )}
                  </ul>
                </div> */}
              </Col>
            </Row>
          </div>
        </Container>
      </section>

      {isDesktop ?
        <div className='rcs_footer_bottom' id="rcs_footer_bottom">
          <Container className="showcase-container rcs_custom_home_container">
            <Row className='w-100 m-auto justify-content-center'>
              <Col xs={12}>
                <div className='rcs_footer_bottom_content text-center'>
                  <p>
                    <span>{client_name.c_name} © {new Date().getFullYear()} All Rights Reserved. Designed and Developed by </span>
                    <a href="https://belgiumwebnet.com/" target="_blank">  <img src={BelgiumLogo} alt="Belgium Logo" width={"18px"} className="ml-2" /> </a>
                  </p>
                </div>
              </Col>
              {/* <Col lg={4} md={4}>
            <ul className='d-flex justify-content-center align-items-center'>
              {
                media_details.map((media, id) =>
                  <li key={id} className='mr-2'>
                    <div className="rcs_footer_content_one_social_icn_div">
                      <a href={media.account_link} target="_blank"  >{media.account_icon}</a>
                    </div>
                  </li>
                )}
            </ul>
          </Col> */}
              {/* <Col lg={4} md={4}>
            <div className="rcs_footer_logo_main">
              <ul>
                <li>
                  <div className="rcs_footer_logo_img_div">
                    <a href="https://www.rapnet.com/" target='_blank' rel="noreferrer">   <Image src={rapnet} alt="Rapnet" /></a>
                  </div>
                </li>
                <li>
                  <div className="rcs_footer_logo_img_div">
                    <a href="https://www.overnightmountings.com/" target='_blank' rel="noreferrer">    <Image src={overnight} alt="Overnight" /></a>
                  </div>
                </li>
                <li>
                  <div className="rcs_footer_logo_img_div">
                    <a href="https://www.vdbapp.com/" target='_blank' rel="noreferrer">  <Image src={vdb} alt="VDB" /></a>
                  </div>
                </li>
                <li>
                  <div className="rcs_footer_logo_img_div">
                    <a href="https://www.ivouch.com/" target='_blank' rel="noreferrer">  <Image src={ivouch} alt="IVach" /></a>
                  </div>
                </li>
                <li>
                  <div className="rcs_footer_logo_img_div">
                    <a href="https://www.yelp.com/" target='_blank' rel="noreferrer">   <Image src={yelp} alt="Yelp" /></a>
                  </div>
                </li>
                <li>
                  <div className="rcs_footer_logo_img_div">
                    <a href="https://www.google.com/" target='_blank' rel="noreferrer">   <Image src={google} alt="Google" /></a>
                  </div>
                </li>
                <li>
                  <div className="rcs_footer_logo_img_div">
                    <a href="https://www.paypal.com/in/webapps/mpp/home?gclsrc=aw.ds&gclid=EAIaIQobChMI7sKht7nn5gIVGAkrCh2VHgXsEAAYASAAEgJAX_D_BwE&gclsrc=aw.ds" target='_blank' rel="noreferrer">   <Image src={paypal} alt="Paypal" /></a>
                  </div>
                </li>
              </ul>
            </div>
          </Col> */}
            </Row>
          </Container>
        </div>
        :
        // Mobile footer
        <div className='rcs_footer_bottom' id="rcs_footer_bottom">
          <div className="showcase-container rcs_custom_home_container">
            <Row className='w-100 m-auto justify-content-center'>

              {/* <Col lg={4} md={4}>
              <ul className='d-flex justify-content-center align-items-center'>
                {
                  media_details.map((media, id) =>
                    <li key={id} className='mr-2'>
                      <div className="rcs_footer_content_one_social_icn_div">
                        <a href={media.account_link} target="_blank"  >{media.account_icon}</a>
                      </div>
                    </li>
                  )}
              </ul>
            </Col> */}
              {/* <Col lg={4} md={4}>
              <div className="rcs_footer_logo_main">
                <ul>
                  <li>
                    <div className="rcs_footer_logo_img_div">
                      <a href="https://www.rapnet.com/" target='_blank' rel="noreferrer">   <Image src={rapnet} alt="Rapnet" /></a>
                    </div>
                  </li>
                  <li>
                    <div className="rcs_footer_logo_img_div">
                      <a href="https://www.overnightmountings.com/" target='_blank' rel="noreferrer">    <Image src={overnight} alt="Overnight" /></a>
                    </div>
                  </li>
                  <li>
                    <div className="rcs_footer_logo_img_div">
                      <a href="https://www.vdbapp.com/" target='_blank' rel="noreferrer">  <Image src={vdb} alt="VDB" /></a>
                    </div>
                  </li>
                  <li>
                    <div className="rcs_footer_logo_img_div">
                      <a href="https://www.ivouch.com/" target='_blank' rel="noreferrer">  <Image src={ivouch} alt="IVach" /></a>
                    </div>
                  </li>
                  <li>
                    <div className="rcs_footer_logo_img_div">
                      <a href="https://www.yelp.com/" target='_blank' rel="noreferrer">   <Image src={yelp} alt="Yelp" /></a>
                    </div>
                  </li>
                  <li>
                    <div className="rcs_footer_logo_img_div">
                      <a href="https://www.google.com/" target='_blank' rel="noreferrer">   <Image src={google} alt="Google" /></a>
                    </div>
                  </li>
                  <li>
                    <div className="rcs_footer_logo_img_div">
                      <a href="https://www.paypal.com/in/webapps/mpp/home?gclsrc=aw.ds&gclid=EAIaIQobChMI7sKht7nn5gIVGAkrCh2VHgXsEAAYASAAEgJAX_D_BwE&gclsrc=aw.ds" target='_blank' rel="noreferrer">   <Image src={paypal} alt="Paypal" /></a>
                    </div>
                  </li>
                </ul>
              </div>
            </Col> */}
              <Col xs={12} >
                <div className='rcs_footer_bottom_content text-center'>
                  <p >
                    <span>{client_name.c_name} © {new Date().getFullYear()} All Rights Reserved. Designed and Developed by </span>
                    <a href="https://belgiumwebnet.com/" target="_blank">  <img src={BelgiumLogo} alt="Belgium Logo" width={"18px"} className="ml-2" /> </a>

                  </p>
                </div>
              </Col>
            </Row>
          </div>
        </div>}
      {/* Whatsapp Chat */}
      {/* <a href="https://wa.me/+16469929024" class="whatsapp_float" target="_blank" rel="noopener noreferrer">
        <Image src={whatsapp} alt="whatspp chat"></Image>
      </a> */}
      {/* Whatsapp Chat */}
      {/* <div className='rcs_footer_chat'>
        <div className='rcs_diamond_specialist'>
        </div>
        <div className='rcs_diamond_tdo_chat'>
        </div>
      </div> */}
      <FloatingWhatsApp phoneNumber='+34649891997' avatar={WPimg} accountName='Manuel Spinosa' className='mt-3 float-left' />


      <Container>
        <div className='seo_urlsss'>
          <ul>
            <li><a href="https://manuelspinosa.com/bracelets">https://manuelspinosa.com/bracelets</a></li>
            <li><a href="https://manuelspinosa.com/fine-jewelry">https://manuelspinosa.com/fine-jewelry</a></li>
            <li><a href="https://manuelspinosa.com/necklaces">https://manuelspinosa.com/necklaces</a></li>
            <li><a href="https://manuelspinosa.com/blog">https://manuelspinosa.com/blog</a></li>
            <li><a href="https://manuelspinosa.com/education">https://manuelspinosa.com/education</a></li>
            <li><a href="https://manuelspinosa.com/earrings">https://manuelspinosa.com/earrings</a></li>
            <li><a href="https://manuelspinosa.com/fine-jewelry/pendants">https://manuelspinosa.com/pendants</a></li>
            <li><a href="https://manuelspinosa.com/wedding-rings/style=Anniversary">https://manuelspinosa.com/wedding-rings/style=Anniversary</a></li>
            <li><a href="https://manuelspinosa.com/wedding-rings/style=Plain%20Metal">https://manuelspinosa.com/wedding-rings/style=Plain%20Metal</a></li>
            <li><a href="https://manuelspinosa.com/wedding-rings/style=Channel%20Set">https://manuelspinosa.com/wedding-rings/style=Channel%20Set</a></li>
            <li><a href="https://manuelspinosa.com/wedding-rings/material=18K-Rose-Gold">https://manuelspinosa.com/wedding-rings/material=18K-Rose-Gold</a></li>
            <li><a href="https://manuelspinosa.com/wedding-rings/material=18K-Yellow-Gold">https://manuelspinosa.com/wedding-rings/material=18K-Yellow-Gold</a></li>
            <li><a href="https://manuelspinosa.com/wedding-rings/material=18K-White-Gold">https://manuelspinosa.com/wedding-rings/material=18K-White-Gold</a></li>
            <li><a href="https://manuelspinosa.com/fine-jewelry/material=18K-Rose-Gold">https://manuelspinosa.com/fine-jewelry/material=18K-Rose-Gold</a></li>
            <li><a href="https://manuelspinosa.com/fine-jewelry/material=18K-Yellow-Gold">https://manuelspinosa.com/fine-jewelry/material=18K-Yellow-Gold</a></li>
            <li><a href="https://manuelspinosa.com/fine-jewelry/material=18K-White-Gold">https://manuelspinosa.com/fine-jewelry/material=18K-White-Gold</a></li>
            <li><a href="https://manuelspinosa.com/engagement-rings">https://manuelspinosa.com/engagement-rings</a></li>
            <li><a href="https://manuelspinosa.com/engagement-rings/style=Halo">https://manuelspinosa.com/engagement-rings/style=Halo</a></li>
            <li><a href="https://manuelspinosa.com/engagement-rings/style=Three%20stone">https://manuelspinosa.com/engagement-rings/style=Three%20stone</a></li>
            <li><a href="https://manuelspinosa.com/engagement-rings/style=Solitaire">https://manuelspinosa.com/engagement-rings/style=Solitaire</a></li>
            <li><a href="https://manuelspinosa.com/engagement-rings/metals=18K-Rose-Gold">https://manuelspinosa.com/engagement-rings/metals=18K-Rose-Gold</a></li>
            <li><a href="https://manuelspinosa.com/engagement-rings/metals=18K-Yellow-Gold">https://manuelspinosa.com/engagement-rings/metals=18K-Yellow-Gold</a></li>
            <li><a href="https://manuelspinosa.com/engagement-rings/metals=18K-White-Gold">https://manuelspinosa.com/engagement-rings/metals=18K-White-Gold</a></li>
            <li><a href="https://manuelspinosa.com/engagement-rings/shape=Round">https://manuelspinosa.com/engagement-rings/shape=Round</a></li>
            <li><a href="https://manuelspinosa.com/engagement-rings/shape=Oval">https://manuelspinosa.com/engagement-rings/shape=Oval</a></li>
            <li><a href="https://manuelspinosa.com/engagement-rings/shape=Emerald">https://manuelspinosa.com/engagement-rings/shape=Emerald</a></li>
            <li><a href="https://manuelspinosa.com/contact">https://manuelspinosa.com/contact</a></li>
            <li><a href="https://manuelspinosa.com/faq">https://manuelspinosa.com/faq</a></li>
            <li><a href="https://manuelspinosa.com/about">https://manuelspinosa.com/about</a></li>
            <li><a href="https://manuelspinosa.com/privacy-policy">https://manuelspinosa.com/privacy-policy</a></li>
            <li><a href="https://manuelspinosa.com/terms-and-conditions">https://manuelspinosa.com/terms-and-conditions</a></li>
            <li><a href="https://manuelspinosa.com/education/engagement-ring-education">https://manuelspinosa.com/education/engagement-ring-education</a></li>
            <li><a href="https://manuelspinosa.com/education/fine-jewelry-education">https://manuelspinosa.com/education/fine-jewelry-education</a></li>
            <li><a href="https://manuelspinosa.com/education/wedding-ring-education">https://manuelspinosa.com/education/wedding-ring-education</a></li>
            <li><a href="https://manuelspinosa.com">https://manuelspinosa.com</a></li>
            <li><a href="https://manuelspinosa.com/2021-gift-guide">https://manuelspinosa.com/2021-gift-guide</a></li>
            <li><a href="https://manuelspinosa.com/ada-compliance">https://manuelspinosa.com/ada-compliance</a></li>
            <li><a href="https://manuelspinosa.com/careers">https://manuelspinosa.com/careers</a></li>
            <li><a href="https://manuelspinosa.com/charities">https://manuelspinosa.com/charities</a></li>
            <li><a href="https://manuelspinosa.com/educational-blog">https://manuelspinosa.com/educational-blog</a></li>
            <li><a href="https://manuelspinosa.com/financing">https://manuelspinosa.com/financing</a></li>
            <li><a href="https://manuelspinosa.com/indian-jewelry">https://manuelspinosa.com/indian-jewelry</a></li>
            <li><a href="https://manuelspinosa.com/insurance">https://manuelspinosa.com/insurance</a></li>
            <li><a href="https://manuelspinosa.com/wedding-rings">https://manuelspinosa.com/wedding-rings</a></li>
            <li><a href="https://manuelspinosa.com/mission-and-vision">https://manuelspinosa.com/mission-and-vision</a></li>
            <li><a href="https://manuelspinosa.com/press-media">https://manuelspinosa.com/press-media</a></li>
            <li><a href="https://manuelspinosa.com/productdetail/14k-rose-freeform-ring-5808122623p">https://manuelspinosa.com/productdetail/14k-rose-freeform-ring-5808122623p</a></li>
            <li><a href="https://manuelspinosa.com/register">https://manuelspinosa.com/register</a></li>
            <li><a href="https://manuelspinosa.com/responsible-sourcing">https://manuelspinosa.com/responsible-sourcing</a></li>
            <li><a href="https://manuelspinosa.com/returns-and-exchanges">https://manuelspinosa.com/returns-and-exchanges</a></li>
            <li><a href="https://manuelspinosa.com/">https://manuelspinosa.com/</a></li>
            <li><a href="https://manuelspinosa.com/sitemap.xml">https://manuelspinosa.com/sitemap.xml</a></li>
          </ul>
        </div>
      </Container>

    </>
  )
}
export default Footer;
